import * as enums from "../enums/enums";

export const cards = (state = [], action) => {
  switch (action.type) {
    case enums.SET_CARDS_JSON:
      return action.json;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/cards.js